let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("92Dsi")).then(() => parcelRequire('B9xUt'));